import React, { useEffect, useState, useRef } from 'react';

const AnimatedHexagonBackground = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const animationRef = useRef(null);
  const targetScrollY = useRef(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Adjust breakpoint as needed
    };

    const handleScroll = () => {
      targetScrollY.current = window.scrollY;
    };

    const smoothParallax = () => {
      setScrollY(current => {
        const diff = targetScrollY.current - current;
        return current + diff * 0.1; // Adjust 0.1 for different smoothness
      });
      animationRef.current = requestAnimationFrame(smoothParallax);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    handleResize(); // Initial check
    smoothParallax();

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
      cancelAnimationFrame(animationRef.current);
    };
  }, []);

  const getScale = (baseScale, mobileMultiplier = 1.4, desktopMultiplier = 1.1) => {
    return isMobile ? baseScale * mobileMultiplier : baseScale * desktopMultiplier;
  };

  const getMobilePosition = (index) => {
    if (isMobile) {
      switch(index) {
        case 0: // This is for about-3-min.png
          return { top: '39%', left: '50%' }; // Adjust these values as needed
        case 2: // This is for about-1-min.png
          return { top: '59%', left: '50%' }; // Adjust these values as needed
        default:
          return { top: '50%', left: '50%' };
      }
    }
    return { top: '50%', left: '50%' };
  };

  return (
    <div className="absolute inset-0 overflow-hidden">
      <div className="nectar_cascading_images animated-in" data-border-radius="none" data-parallax="yes" data-parallax-intensity="subtle" data-layer-1-parallax="no" data-animation-timing="175">
        {/* Fixed Image 4 */}
        <div 
          className="cascading-image" 
          data-has-img="true" 
          style={{ 
            position: 'absolute', 
            top: '50%', 
            left: '50%', 
            transform: 'translate(-50%, -50%)'
          }}
        >
          <div 
            className="inner-wrap" 
            style={{ 
              transition: 'transform 0.5s ease-out', 
              transform: `scale(${getScale(1.5)})`
            }}
          >
            <div className="bg-layer">
              <div className="img-wrap">
                <img 
                  fetchpriority="high"
                  decoding="async" 
                  src="https://gtechniq.com/wp-content/uploads/2020/06/about-4-min.png" 
                  alt="" 
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Parallax Images 3, 2, 1 */}
        {[3, 2, 1].map((num, index) => {
          const position = getMobilePosition(index);
          const scale = getScale(1.5 - index * 0.1);
          return (
            <div 
              key={num} 
              className="cascading-image" 
              data-has-img="true" 
              style={{ 
                position: 'absolute', 
                top: position.top,
                left: position.left,
                transform: `translate(-50%, -50%)`
              }}
            >
              <div 
                className="inner-wrap" 
                style={{ 
                  transition: 'transform 0.5s ease-out', 
                  transform: `scale(${scale}) translateY(${-scrollY * (0.1 * (index + 1)) / scale}px)`
                }}
              >
                <div className="bg-layer">
                  <div className="img-wrap">
                    <img 
                      decoding="async" 
                      src={`https://gtechniq.com/wp-content/uploads/2020/06/about-${num}-min.png`} 
                      alt="" 
                      className="w-full h-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnimatedHexagonBackground;